export default __webpack_public_path__ + "static/media/cpv_35_safety-fire-army-police.02a9b62b.svg";